import styled from '@emotion/styled';
import React from 'react';

interface YoutubeSubscribeProps {
	frameTitle: string;
	channel: string;
}

export const YoutubeSubscribe: React.FC<YoutubeSubscribeProps> = ({
	channel,
	frameTitle,
}) => (
	<SubscribeWrapper>
		<StyledFrame
			title={frameTitle}
			src={`https://www.youtube.com/subscribe_embed?usegapi=1&channel=${channel}&layout=full`}
			height="48"
			width="168"
		/>
	</SubscribeWrapper>
);

const StyledFrame = styled.iframe`
	border: none;
`;

export const SubscribeWrapper = styled.div`
	display: flex;
	justify-content: left;
	align-items: left;
`;
